import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import { LanguageProvider } from "./contexts/LanguageContext";
import { ContentProvider } from "./contexts/ContentContext";
import { AuthProvider } from "./contexts/AuthContext";
import i18n from "./i18n";

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <I18nextProvider i18n={i18n}>
          <ContentProvider>
            <BrowserRouter basename={__BASE_PATH__}>
              <AppRoutes />
            </BrowserRouter>
          </ContentProvider>
        </I18nextProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;